export default "__VITE_ASSET__BpLsBy0M__"